import Button from '@atlaskit/button'
import CrossIcon from '@atlaskit/icon/glyph/cross'
import Modal, { ModalBody, ModalFooter, ModalHeader, ModalTitle } from '@atlaskit/modal-dialog'
import * as React from 'react'
import { ExportToContext } from '../context/ExportToContext'
import { SendUIEvent, OnInstallAddinClicked, SendScreenEvent } from '../services/AnalyticsClient'

export function ExcelDialog({ openOnlineUrl, setDownloadUrl, setOpeningOnline }) {
  const { offlineFileInfo } = React.useContext(ExportToContext)

  const downloadButtonProps = () => {
    if (!offlineFileInfo) return {} // context is not initialized

    if (offlineFileInfo.authRequired) {
      // at the end of flow redirect to the download page
      const finalRedirectUrl = `${window.location.origin}/download-in-progress${window.location.search}`
      const effectiveAuthFlowUrl = new URL(window.location.origin + offlineFileInfo.authFlowUrl)

      // allowed auth flow clientID
      effectiveAuthFlowUrl.searchParams.set('authClientId', 'openInClientApp')
      // redirect URL is whitelisted on backend for clientId=openInClientApp
      effectiveAuthFlowUrl.searchParams.set('redirectTo', finalRedirectUrl)

      return {
        onClick: () => {
          SendUIEvent('clicked', 'button', 'startAuth', 'exportToExcelScreen')
        },
        href: effectiveAuthFlowUrl,
      }
    }

    return {
      onClick: () => {
        SendUIEvent('clicked', 'button', 'downloadFile', 'exportToExcelScreen')
        setDownloadUrl(offlineFileInfo.contentUrl)
      },
    }
  }

  React.useEffect(() => SendScreenEvent('exportToExcelScreen'), []) // run it once

  return (
    <Modal width='small'>
      <ModalHeader>
        <ModalTitle>Select your Excel product</ModalTitle>
      </ModalHeader>
      <ModalBody>
        <p>
          If you use Excel Online, your issues will open in a new spreadsheet in your browser. If
          you're a desktop user, we'll download a file for you to open in Excel.
        </p>
        <p>
          We also suggest the{' '}
          <a
            href='https://appsource.microsoft.com/en-us/product/office/WA200000556'
            onClick={OnInstallAddinClicked}
            rel='noopener noreferrer'
            target='_blank'
          >
            Jira Cloud for Excel
          </a>{' '}
          app to get Jira issues directly from your spreadsheets.
        </p>
      </ModalBody>
      <ModalFooter>
        <Button {...downloadButtonProps()}>Excel on Desktop</Button>
        <Button
          href={openOnlineUrl}
          onClick={() => {
            setOpeningOnline(true)
            SendUIEvent('clicked', 'button', 'openOnline', 'exportToExcelScreen')
          }}
          target='_self'
        >
          Excel Online
        </Button>
      </ModalFooter>
    </Modal>
  )
}
